// src/components/LeftMenu.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './LeftMenu.css'; // Import CSS for styling
import 'bootstrap-icons/font/bootstrap-icons.css';

function LeftMenu() {

    const location = useLocation(); // Use useLocation hook to get the current path
    const { isPremium } = useSelector(state => state.globalData);

    return (
        <div className="left-menu">
            <Link to="/" className={`menu-item ${location.pathname === '/' ? 'active' : ''}`}>
                <img width='175px' alt='logo' src={require(`../images/logo/all_bgs/logo${isPremium ? '16' : '8'}b.png`)}/>
            </Link>
            <Link style={{ paddingTop: '30px' }} to="/Simulator" className={`menu-item ${location.pathname === '/Simulator' ? 'active' : ''}`}>
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-graph-up"></i>
                </span>
                Simulation
            </Link>
            <Link to="/Indicators" className={`menu-item ${location.pathname === '/Indicators' ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-bar-chart-line-fill"></i>
                </span>  
                Indicators
            </Link>
            <Link to="/StrategySettings" className={`menu-item ${location.pathname === '/StrategySettings' ? 'active' : ''}`}>
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-gear-fill"></i>
                </span>                
                Strategy Settings
            </Link>            
            <Link to="/MySpace" className={`menu-item ${location.pathname.startsWith('/MySpace') ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-person-workspace"></i>
                </span>
                My Space
            </Link>
            <div style={{display:'flex', alignItems:'center'}}>
            <Link to="/Investments" className={`menu-item ${location.pathname === '/Investments' ? 'active' : ''}`}>               
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-coin"></i>
                </span> 
                Investments 
            </Link>
            <div className='new'>new</div>
            </div>
            <Link to="/FearAndGreed" className={`menu-item ${location.pathname === '/FearAndGreed' ? 'active' : ''}`}>               
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-rainbow"></i>
                </span> 
                Fear And Greed
            </Link>
            <Link to="/TRViewFacts" className={`menu-item ${location.pathname === '/TRViewFacts' ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-clipboard-data"></i>
                </span> 
                Market Indexes
            </Link>
            <Link to="/TopBuySell" className={`menu-item ${location.pathname === '/TopBuySell' ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-bar-chart-steps"></i>
                </span> 
                Top Buy and Sell
            </Link>           
            <Link to="/News/0" className={`menu-item ${location.pathname.startsWith('/News') ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-newspaper"></i>
                </span>
                Crypto News
            </Link>       
            <Link to="/Shop" className={`menu-item ${location.pathname.startsWith('/Shop') ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-currency-dollar"></i>
                </span>
                Buy Plan
            </Link>       
            <Link to="/Wallets" className={`menu-item ${location.pathname.startsWith('/Wallets') ? 'active' : ''}`}>                
                <span className="rotate-icon" style={{ marginRight: '20px', fontSize: '18pt' }}>
                    <i className="bi bi-wallet2"></i>
                </span>
                Wallets
            </Link>                         
            {/* <Link to="/Temp" className={`menu-item ${location.pathname.startsWith('/Temp') ? 'active' : ''}`}>
                <i className="bi bi-clock-history" style={{ marginRight: '20px', fontSize:'18pt' }}></i>
                Temp
            </Link>        */}
        </div>
    );
}

export default LeftMenu;
